import { Redirect } from 'expo-router';
import Head from 'expo-router/head';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { ScreenContent } from '@fhs/screen-content';
import { tokens, useMqSelect } from '@fhs/ui';
import Footer from 'components/footer';
import { PaymentMethodFlatListWithButton } from 'components/payment-method-flat-list-with-button';
import { useAuthContext } from 'state/auth';
import { usePaymentContext } from 'state/payment';
import { routes } from 'utils/routing';

const PaymentMethods = () => {
  const { isAuthenticated, refreshCurrentUser } = useAuthContext();
  const { getPaymentMethods } = usePaymentContext();
  const { formatMessage } = useIntl();
  const isDesktop = useMqSelect({ $gteDesktop: true }, false);

  // Refetch user first so default payment method is current (e.g. after vaulting a card at checkout), then refetch payment methods
  useEffect(() => {
    if (!isAuthenticated) return;
    let cancelled = false;
    (async () => {
      if (refreshCurrentUser) await refreshCurrentUser();
      if (!cancelled && getPaymentMethods) await getPaymentMethods();
    })();
    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, refreshCurrentUser, getPaymentMethods]);

  if (!isAuthenticated) {
    return <Redirect href={routes.base} />;
  }

  return (
    <>
      <Head>
        <title>{`${formatMessage({ id: 'paymentMethods' })} - Firehouse Subs`}</title>
      </Head>
      <ScreenContent
        after={isDesktop ? <Footer /> : <></>}
        style={{ backgroundColor: tokens.colors.$white }}
      >
        <PaymentMethodFlatListWithButton />
      </ScreenContent>
    </>
  );
};

export default PaymentMethods;
